/**
 * 同意書問卷作答的唯讀顯示。
 *
 * 預約詳情、客戶詳情、簽署紀錄三個地方都要把同一組答案畫出來，
 * 格式若各寫各的，日後多一種題型就得改三處、還會長得不一樣。
 *
 * 資料來源一律是簽署存證裡的 answers（含作答當下的題目與選項文字），
 * 所以就算範本後來改題或整份刪掉，這裡顯示的仍是客戶當時答的內容。
 */
import React from 'react'
import styled from 'styled-components'

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const Item = styled.div`
  display: flex;
  gap: 12px;
  align-items: baseline;

  .q {
    flex: 0 0 42%;
    min-width: 0;
    color: #86868b;
    font-size: 13px;
    line-height: 1.5;
  }

  .a {
    flex: 1 1 auto;
    min-width: 0;
    color: #1d1d1f;
    font-weight: 600;
    font-size: 13px;
    line-height: 1.5;
    word-break: break-word;
  }

  /* 手機一行放不下問答並排，改成上下 */
  @media (max-width: 576px) {
    flex-direction: column;
    gap: 2px;

    .q {
      flex: none;
    }
  }
`

const formatAnswer = (answer) => {
  if (!answer) return '—'
  if (answer.type === 'text') return answer.textValue || '—'
  const labels = answer.selectedLabels || []
  return labels.length ? labels.join('、') : '—'
}

const ConsentAnswerList = ({ answers = [] }) => {
  if (!answers.length) return null
  return (
    <List>
      {answers.map((a) => (
        <Item key={a.key}>
          <span className='q'>{a.label}</span>
          <span className='a'>{formatAnswer(a)}</span>
        </Item>
      ))}
    </List>
  )
}

export default ConsentAnswerList
